'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeWidth={2} d="M7 19a3 3 0 1 1-2-2.83M7 19a3 3 0 0 0-2-2.83M7 19h10M5 16.17l5-8.93M15 5c0 .888-.386 1.687-1 2.236A3 3 0 0 1 12 8c-.768 0-1.47-.289-2-.764A3 3 0 1 1 15 5ZM19 16.17a3.001 3.001 0 1 0 2.002 5.66A3.001 3.001 0 0 0 19 16.17Zm0 0-5-8.93" /></svg>;
const IconShare = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconShare;